import { render, staticRenderFns } from "./ConfigureGraphCollection.vue?vue&type=template&id=6f9d816f&scoped=true&"
import script from "./ConfigureGraphCollection.ts?vue&type=script&lang=ts&"
export * from "./ConfigureGraphCollection.ts?vue&type=script&lang=ts&"
import style0 from "./ConfigureGraphCollection.scss?vue&type=style&index=0&id=6f9d816f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d816f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VColorPicker,VDivider,VForm,VRow,VTextField})
